// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─────────── LAYOUT ─────────── */

.help-page {
  max-width: var(--max-width-10xl, 120rem);
  margin: 0 auto;
  padding: 22px 24px 48px;
  font-family: "DM Sans", sans-serif;
}

.help-page-container {
  max-width: 1400px;
  margin: 0 0 20px;
  padding: 0;
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  align-items: flex-start;
  box-sizing: border-box;
}

.help-chat {
  flex: 2 1 500px;
  min-width: 0;
}

/* Both panels share one frame so the two columns read as a matched pair. */
.chat-assistant-container,
.help-actions {
  background: #fff;
  border: 1px solid #e6e6ee;
  border-radius: 14px;
  box-shadow: 0 1px 2px rgba(20, 10, 50, 0.04),
    0 12px 30px -20px rgba(20, 10, 50, 0.28);
  overflow: hidden;
  box-sizing: border-box;
}

.chat-assistant-container {
  display: flex;
  flex-direction: column;
  height: 700px;
  max-height: 80vh;
}

.help-actions {
  flex: 1 1 320px;
  min-width: 0;
}

/* ─────────── ACTIONS PANEL ─────────── */

/* Purple band that mirrors the assistant's own header inside the iframe.
   60px = the hosted chat header's rendered height (measured in the live
   iframe), so the two header edges line up across the two columns. */
.help-actions-head {
  display: flex;
  align-items: center;
  gap: 11px;
  min-height: 60px;
  padding: 12px 18px;
  background: linear-gradient(120deg, #5616ea 0%, #6c29f1 100%);
  color: #fff;
  box-sizing: border-box;
}

.help-actions-head-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  box-sizing: border-box;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.16);
  border: 1px solid rgba(255, 255, 255, 0.22);
  font-size: 14px;
}

.help-actions-head-title {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #fff;
}

/* ─────────── CONTACT OPTIONS ─────────── */

.help-option {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 20px 18px;
  background: none;
  border: none;
  text-align: left;
  font-family: inherit;
  cursor: pointer;
  box-sizing: border-box;
  transition: background-color 0.2s ease;
}
/* The thin divider between the options. */
.help-option + .help-option {
  border-top: 1px solid #eeeef3;
}
.help-option:hover {
  background: #faf9ff;
}
.help-option:focus-visible {
  outline: 2px solid #5616ea;
  outline-offset: -2px;
}

.help-option-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 11px;
  background: #f6f5f9;
  border: 1px solid #ececf1;
  color: #5616ea;
  font-size: 16px;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}
.help-option:hover .help-option-icon {
  background: #f1eaff;
  border-color: #d9cbfa;
}

.help-option-text {
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex: 1 1;
  min-width: 0;
}
.help-option-title {
  font-size: 14.5px;
  font-weight: 700;
  color: #20202a;
}
.help-option-desc {
  font-size: 13px;
  line-height: 1.5;
  color: #6c6c78;
}
.help-option-desc strong {
  font-weight: 600;
  color: #4a4a55;
}

.help-option-arrow {
  flex-shrink: 0;
  font-size: 12px;
  color: #b9b9c6;
  transition: transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    color 0.2s ease;
}
.help-option:hover .help-option-arrow {
  transform: translateX(3px);
  color: #5616ea;
}

/* ─────────── SHARED CHAT CLASSES (legacy) ───────────
   The help page renders the assistant in an iframe and no longer uses the
   rules below, but CRA bundles every stylesheet globally and other chat
   surfaces (chatHistoryOverview, chatModal, BotChatStep) still pick up
   .chat-messages / .send-button / .loading-dots from here. Leave them. */

.chat-messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 8px 24px 8px 16px;
}

.message { display: flex; margin-bottom: 10px; font-size: 16px; line-height: 1.5; }
.user-message { justify-content: flex-end; }
.bot-message  { justify-content: flex-start; }

/* bubbles */
.user-chat-bubble,
.bot-chat-bubble {
  padding: 8px 12px;
  border-radius: 10px;
  max-width: 70%;
  word-wrap: break-word;
}
.user-chat-bubble { background: #f2f2f2; color: #000; }
.bot-chat-bubble  { background: #fff; color: #333; }

.bot-chat-bubble a { color: #5616ea; font-weight: 500; text-decoration: underline; }

/* markdown spacing tweaks */
.bot-chat-bubble p { margin: 0 0 .9em; }
.bot-chat-bubble ul,
.bot-chat-bubble ol { margin: .9em 0; padding-left: 1.25em; }
.bot-chat-bubble li { margin: .25em 0; }

/* avatars */
.bot-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
  background: #5616ea;
  border-radius: 50%;
  flex-shrink: 0;
}
.bot-icon-text { color: #fff; text-align: center; margin-bottom: 7px;}

.user-icon-help img {
  height: 32px;
  width: 32px;
  border-radius: 50%;
  margin-left: 8px;
  margin-top: 2px;
}

/* loading dots */
.loading-dots {
  display: flex;
  justify-content: left;
  align-items: center;
  height: 40px;
  margin-top: 10px;
  margin-bottom: 5px;
  margin-left: 10px;
}
.loading-dots div {
  width: 8px;
  height: 8px;
  margin: 0 4px;
  border-radius: 50%;
  background-color: #5616ea;
  animation: loading-bounce 0.6s infinite alternate;
}
@keyframes loading-bounce {
  to { transform: translateY(-6px); }
}
.loading-dots div:nth-child(2) {
  animation-delay: 0.2s;
}
.loading-dots div:nth-child(3) {
  animation-delay: 0.4s;
}

/* initial loading spinner */
.chat-initial-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex: 1 1;
}
.chat-loading-spinner {
  font-size: 36px;
  color: #5616ea;
}

/* input bar */
.chat-input-bar {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  padding: 12px 16px;
  background: #fafafa;
  border-top: 1px solid #f1f1f1;
  box-sizing: border-box;
}
.chat-input-bar textarea {
  flex: 1 1;
  font-size: 16px;
  padding: 6px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  outline: none;
  resize: none;
  line-height: 1.4;
  max-height: 140px;
  overflow-y: hidden;
  font-family: inherit;
  box-sizing: border-box;
}
.chat-input-bar textarea.has-overflow {
  overflow-y: auto;
}
.send-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #5616ea;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0 15px;
  height: 34px;
  cursor: pointer;
  transition: background 0.2s ease;
}
.send-button:disabled { opacity: .55; cursor: not-allowed; }
.send-button:not(:disabled):hover { background: #4a14d6; }
.send-icon {
  width: 16px;
  height: 16px;
  fill: currentColor;
  display: block;
}

/* ─────────── RESPONSIVE ─────────── */

@media (max-width: 992px) {
  .chat-assistant-container { height: 600px; }
}
@media (max-width: 768px) {
  .help-page-container { gap: 20px; }
  .help-chat,
  .help-actions { flex: 1 1 100%; }
  .chat-assistant-container { height: 75vh; }
}
@media (max-width: 480px) {
  .help-page { padding: 22px 16px 40px; }
  .help-option { padding: 16px 14px; gap: 12px; }
  .chat-messages { padding: 14px 16px 6px 10px; }
  .chat-input-bar { padding: 10px; }
}
`, "",{"version":3,"sources":["webpack://./src/components/helpPage.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAEnC;EACE,wCAAwC;EACxC,cAAc;EACd,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,2EAA2E;AAC3E;;EAEE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB;4CAC0C;EAC1C,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,0CAA0C;;AAE1C;;qEAEqE;AACrE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,6DAA6D;EAC7D,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;;AAEA,4CAA4C;;AAE5C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,sBAAsB;EACtB,sCAAsC;AACxC;AACA,0CAA0C;AAC1C;EACE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,8DAA8D;AAChE;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd;mBACiB;AACnB;AACA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;;;;yEAIyE;;AAEzE;EACE,SAAO;EACP,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,WAAW,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAClF,gBAAgB,yBAAyB,EAAE;AAC3C,gBAAgB,2BAA2B,EAAE;;AAE7C,YAAY;AACZ;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA,oBAAoB,mBAAmB,EAAE,WAAW,EAAE;AACtD,oBAAoB,gBAAgB,EAAE,WAAW,EAAE;;AAEnD,qBAAqB,cAAc,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;;AAEnF,4BAA4B;AAC5B,qBAAqB,gBAAgB,EAAE;AACvC;sBACsB,cAAc,EAAE,oBAAoB,EAAE;AAC5D,sBAAsB,eAAe,EAAE;;AAEvC,YAAY;AACZ;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA,iBAAiB,WAAW,EAAE,kBAAkB,EAAE,kBAAkB,CAAC;;AAErE;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,iDAAiD;AACnD;AACA;EACE,KAAK,2BAA2B,EAAE;AACpC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,SAAO;AACT;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB;AACxB;AACA;EACE,SAAO;EACP,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,gCAAgC;AAClC;AACA,wBAAwB,YAAY,EAAE,mBAAmB,EAAE;AAC3D,oCAAoC,mBAAmB,EAAE;AACzD;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA,uCAAuC;;AAEvC;EACE,4BAA4B,aAAa,EAAE;AAC7C;AACA;EACE,uBAAuB,SAAS,EAAE;EAClC;kBACgB,cAAc,EAAE;EAChC,4BAA4B,YAAY,EAAE;AAC5C;AACA;EACE,aAAa,uBAAuB,EAAE;EACtC,eAAe,kBAAkB,EAAE,SAAS,EAAE;EAC9C,iBAAiB,2BAA2B,EAAE;EAC9C,kBAAkB,aAAa,EAAE;AACnC","sourcesContent":["/* ─────────── LAYOUT ─────────── */\r\n\r\n.help-page {\r\n  max-width: var(--max-width-10xl, 120rem);\r\n  margin: 0 auto;\r\n  padding: 22px 24px 48px;\r\n  font-family: \"DM Sans\", sans-serif;\r\n}\r\n\r\n.help-page-container {\r\n  max-width: 1400px;\r\n  margin: 0 0 20px;\r\n  padding: 0;\r\n  display: flex;\r\n  gap: 24px;\r\n  flex-wrap: wrap;\r\n  align-items: flex-start;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.help-chat {\r\n  flex: 2 1 500px;\r\n  min-width: 0;\r\n}\r\n\r\n/* Both panels share one frame so the two columns read as a matched pair. */\r\n.chat-assistant-container,\r\n.help-actions {\r\n  background: #fff;\r\n  border: 1px solid #e6e6ee;\r\n  border-radius: 14px;\r\n  box-shadow: 0 1px 2px rgba(20, 10, 50, 0.04),\r\n    0 12px 30px -20px rgba(20, 10, 50, 0.28);\r\n  overflow: hidden;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.chat-assistant-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 700px;\r\n  max-height: 80vh;\r\n}\r\n\r\n.help-actions {\r\n  flex: 1 1 320px;\r\n  min-width: 0;\r\n}\r\n\r\n/* ─────────── ACTIONS PANEL ─────────── */\r\n\r\n/* Purple band that mirrors the assistant's own header inside the iframe.\r\n   60px = the hosted chat header's rendered height (measured in the live\r\n   iframe), so the two header edges line up across the two columns. */\r\n.help-actions-head {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 11px;\r\n  min-height: 60px;\r\n  padding: 12px 18px;\r\n  background: linear-gradient(120deg, #5616ea 0%, #6c29f1 100%);\r\n  color: #fff;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.help-actions-head-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 32px;\r\n  height: 32px;\r\n  flex-shrink: 0;\r\n  box-sizing: border-box;\r\n  border-radius: 50%;\r\n  background: rgba(255, 255, 255, 0.16);\r\n  border: 1px solid rgba(255, 255, 255, 0.22);\r\n  font-size: 14px;\r\n}\r\n\r\n.help-actions-head-title {\r\n  margin: 0;\r\n  font-size: 17px;\r\n  font-weight: 700;\r\n  letter-spacing: -0.01em;\r\n  color: #fff;\r\n}\r\n\r\n/* ─────────── CONTACT OPTIONS ─────────── */\r\n\r\n.help-option {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 14px;\r\n  width: 100%;\r\n  padding: 20px 18px;\r\n  background: none;\r\n  border: none;\r\n  text-align: left;\r\n  font-family: inherit;\r\n  cursor: pointer;\r\n  box-sizing: border-box;\r\n  transition: background-color 0.2s ease;\r\n}\r\n/* The thin divider between the options. */\r\n.help-option + .help-option {\r\n  border-top: 1px solid #eeeef3;\r\n}\r\n.help-option:hover {\r\n  background: #faf9ff;\r\n}\r\n.help-option:focus-visible {\r\n  outline: 2px solid #5616ea;\r\n  outline-offset: -2px;\r\n}\r\n\r\n.help-option-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 40px;\r\n  height: 40px;\r\n  flex-shrink: 0;\r\n  border-radius: 11px;\r\n  background: #f6f5f9;\r\n  border: 1px solid #ececf1;\r\n  color: #5616ea;\r\n  font-size: 16px;\r\n  transition: background-color 0.2s ease, border-color 0.2s ease;\r\n}\r\n.help-option:hover .help-option-icon {\r\n  background: #f1eaff;\r\n  border-color: #d9cbfa;\r\n}\r\n\r\n.help-option-text {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 3px;\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n.help-option-title {\r\n  font-size: 14.5px;\r\n  font-weight: 700;\r\n  color: #20202a;\r\n}\r\n.help-option-desc {\r\n  font-size: 13px;\r\n  line-height: 1.5;\r\n  color: #6c6c78;\r\n}\r\n.help-option-desc strong {\r\n  font-weight: 600;\r\n  color: #4a4a55;\r\n}\r\n\r\n.help-option-arrow {\r\n  flex-shrink: 0;\r\n  font-size: 12px;\r\n  color: #b9b9c6;\r\n  transition: transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94),\r\n    color 0.2s ease;\r\n}\r\n.help-option:hover .help-option-arrow {\r\n  transform: translateX(3px);\r\n  color: #5616ea;\r\n}\r\n\r\n/* ─────────── SHARED CHAT CLASSES (legacy) ───────────\r\n   The help page renders the assistant in an iframe and no longer uses the\r\n   rules below, but CRA bundles every stylesheet globally and other chat\r\n   surfaces (chatHistoryOverview, chatModal, BotChatStep) still pick up\r\n   .chat-messages / .send-button / .loading-dots from here. Leave them. */\r\n\r\n.chat-messages {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 8px 24px 8px 16px;\r\n}\r\n\r\n.message { display: flex; margin-bottom: 10px; font-size: 16px; line-height: 1.5; }\r\n.user-message { justify-content: flex-end; }\r\n.bot-message  { justify-content: flex-start; }\r\n\r\n/* bubbles */\r\n.user-chat-bubble,\r\n.bot-chat-bubble {\r\n  padding: 8px 12px;\r\n  border-radius: 10px;\r\n  max-width: 70%;\r\n  word-wrap: break-word;\r\n}\r\n.user-chat-bubble { background: #f2f2f2; color: #000; }\r\n.bot-chat-bubble  { background: #fff; color: #333; }\r\n\r\n.bot-chat-bubble a { color: #5616ea; font-weight: 500; text-decoration: underline; }\r\n\r\n/* markdown spacing tweaks */\r\n.bot-chat-bubble p { margin: 0 0 .9em; }\r\n.bot-chat-bubble ul,\r\n.bot-chat-bubble ol { margin: .9em 0; padding-left: 1.25em; }\r\n.bot-chat-bubble li { margin: .25em 0; }\r\n\r\n/* avatars */\r\n.bot-icon {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 40px;\r\n  width: 40px;\r\n  background: #5616ea;\r\n  border-radius: 50%;\r\n  flex-shrink: 0;\r\n}\r\n.bot-icon-text { color: #fff; text-align: center; margin-bottom: 7px;}\r\n\r\n.user-icon-help img {\r\n  height: 32px;\r\n  width: 32px;\r\n  border-radius: 50%;\r\n  margin-left: 8px;\r\n  margin-top: 2px;\r\n}\r\n\r\n/* loading dots */\r\n.loading-dots {\r\n  display: flex;\r\n  justify-content: left;\r\n  align-items: center;\r\n  height: 40px;\r\n  margin-top: 10px;\r\n  margin-bottom: 5px;\r\n  margin-left: 10px;\r\n}\r\n.loading-dots div {\r\n  width: 8px;\r\n  height: 8px;\r\n  margin: 0 4px;\r\n  border-radius: 50%;\r\n  background-color: #5616ea;\r\n  animation: loading-bounce 0.6s infinite alternate;\r\n}\r\n@keyframes loading-bounce {\r\n  to { transform: translateY(-6px); }\r\n}\r\n.loading-dots div:nth-child(2) {\r\n  animation-delay: 0.2s;\r\n}\r\n.loading-dots div:nth-child(3) {\r\n  animation-delay: 0.4s;\r\n}\r\n\r\n/* initial loading spinner */\r\n.chat-initial-loading {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100%;\r\n  flex: 1;\r\n}\r\n.chat-loading-spinner {\r\n  font-size: 36px;\r\n  color: #5616ea;\r\n}\r\n\r\n/* input bar */\r\n.chat-input-bar {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  gap: 10px;\r\n  padding: 12px 16px;\r\n  background: #fafafa;\r\n  border-top: 1px solid #f1f1f1;\r\n  box-sizing: border-box;\r\n}\r\n.chat-input-bar textarea {\r\n  flex: 1;\r\n  font-size: 16px;\r\n  padding: 6px 12px;\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 6px;\r\n  outline: none;\r\n  resize: none;\r\n  line-height: 1.4;\r\n  max-height: 140px;\r\n  overflow-y: hidden;\r\n  font-family: inherit;\r\n  box-sizing: border-box;\r\n}\r\n.chat-input-bar textarea.has-overflow {\r\n  overflow-y: auto;\r\n}\r\n.send-button {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: #5616ea;\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 8px;\r\n  padding: 0 15px;\r\n  height: 34px;\r\n  cursor: pointer;\r\n  transition: background 0.2s ease;\r\n}\r\n.send-button:disabled { opacity: .55; cursor: not-allowed; }\r\n.send-button:not(:disabled):hover { background: #4a14d6; }\r\n.send-icon {\r\n  width: 16px;\r\n  height: 16px;\r\n  fill: currentColor;\r\n  display: block;\r\n}\r\n\r\n/* ─────────── RESPONSIVE ─────────── */\r\n\r\n@media (max-width: 992px) {\r\n  .chat-assistant-container { height: 600px; }\r\n}\r\n@media (max-width: 768px) {\r\n  .help-page-container { gap: 20px; }\r\n  .help-chat,\r\n  .help-actions { flex: 1 1 100%; }\r\n  .chat-assistant-container { height: 75vh; }\r\n}\r\n@media (max-width: 480px) {\r\n  .help-page { padding: 22px 16px 40px; }\r\n  .help-option { padding: 16px 14px; gap: 12px; }\r\n  .chat-messages { padding: 14px 16px 6px 10px; }\r\n  .chat-input-bar { padding: 10px; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
